<template>
    <div id="content" v-show="!loading && entity">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
                </p>
                <p class="buttons">
                    <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                       @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
                </p>
                <h1 v-if="entity.name">{{ entity.name }}</h1>
            </div>

            <div class="responsiveTabs r-tabs" v-if="!loading">
                <ul class="tabs">
                  <li :class="getActiveTabClass('attributes')">
                    <a @click.prevent.stop="activateTab('attributes')" v-translate>Vlastnosti</a>
                  </li>
                  <li :class="getActiveTabClass('operators')" v-if="$_loggedUser_action_allowed('operators')">
                    <a @click.prevent.stop="activateTab('operators')">{{ $gettext('Operátoři') + ' (' + entity.operators.length +')'}}</a>
                  </li>
                  <li :class="getActiveTabClass('services')" v-if="$_loggedUser_action_allowed('services')">
                    <a @click.prevent.stop="activateTab('services')">{{ $gettext('Služby') + ' (' + entity.services.length +')'}}</a>
                  </li>
                  <li :class="getActiveTabClass('channel_packages')" v-if="$_loggedUser_action_allowed('packages')">
                    <a @click.prevent.stop="activateTab('channel_packages')">{{ $gettext('Balíčky') + ' (' + entity.channel_packages.length +')'}}</a>
                  </li>
                </ul>

                <div class="tabs_content" v-show="isActiveTab('attributes')">
                    <section>
                        <div class="left">
                          <detail-entity-info :entity="entity"></detail-entity-info>
                        </div>
                        <settings-form
                                :entity="entity"
                                ref="businessmodelformref"
                        ></settings-form>
                    </section>
                  <SubscriberProfileForm
                      :entity="entity"
                      :is-editable="$_updateActionAllowed"
                  />
                  <VodProviders
                      :entity="entity"
                      :is-editable="$_updateActionAllowed"
                      :id-business-model="entity.id"
                  ></VodProviders>
                  <AdvertisingProviders
                      :entity="entity"
                      :is-editable="$_updateActionAllowed"
                      :id-business-model="entity.id"
                  ></AdvertisingProviders>

                    <section class="buttons">
                        <p>
                            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                            </router-link>
                            <input v-if="$_updateActionAllowed" type="submit" :value="'Uložit' | translate"
                                   :class="['btn']"
                                   @click.prevent.stop="submitForm()">
                        </p>
                    </section>
                </div>

                <div class="tabs_content"
                     v-if="isActiveTab('operators') && $_loggedUser_action_allowed('operators')"
                     key="operators_tab">
                  <OperatorList :entity="entity" />
                </div>

                <div class="tabs_content"
                     v-if="isActiveTab('services') && $_loggedUser_action_allowed('services')"
                     key="services_tab">
                  <ServiceList :entity="entity" />
                </div>

                <div class="tabs_content"
                     v-if="isActiveTab('channel_packages') && $_loggedUser_action_allowed('packages')"
                     key="chanel_packages_tab">
                  <ChannelPackageList :entity="entity" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import SettingsForm from "./Forms/SettingsForm.vue";
  import SubscriberProfileForm from "./Forms/SubscriberProfileForm.vue";
	import detailActions from "@/components/mixins/detail-actions"
	import businessModels from "@/components/views/businessModels/mixins/businessModels"
  import OperatorList from "./tabs/OperatorList";
	import ServiceList from "./tabs/ServiceList";
  import ChannelPackageList from "./tabs/ChannelPackageList";
  import VodProviders from "./Forms/VodProviders.vue";
  import AdvertisingProviders from "./Forms/AdvertisingProviders.vue";

	export default {
    name: "BusinessModelDetail",
    components: {
      AdvertisingProviders, ChannelPackageList, OperatorList, ServiceList,
      SettingsForm, SubscriberProfileForm, VodProviders
    },
		mixins: [detailActions, businessModels],
		created(BusinessModelService, VodProviderService) {
			this.entityService = BusinessModelService;
      this.vodProviderService = VodProviderService;
			this.createdInit()
		},
    mounted() {
      this.activateTab("attributes");
    },
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.entity = data.business_model
						this.emptyMessage()
					})
					.then(() => {
						this.$refs['businessmodelformref'].validateProtocolFormRequiredFields()
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			updateEntity(params, redirect = false) {
				this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
					.then(() => {
						if (redirect === true) {
							this.redirect(this.moduleName)
						} else {
							this.emptyMessage()
							this.setSuccessMessage()
							this.getEntity()
						}
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error))
					}.bind(this))
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/BusinessModelDetail.vue